<template lang="pug">
    include ../../media/pug/mixins.pug
    +b.HEADER.page-header(id="header")
         +e.big-container._grey_top
            +e.top-line(v-if="!isMobile")
                rsl-header-top-line(
                    v-if="$route.name === 'Document' || getGeneralInfo.isLogin"
                    v-bind:icons="icons"
                    v-bind:currentLang="currentLang"
                    v-bind:loginLink="loginLink"
                    v-bind:logoutLink="logoutLink"
                    v-bind:isAuthorized="getGeneralInfo.isLogin"
                    v-bind:isMobile="isMobile"
                    v-bind:userName="getUserName"
                    v-bind:isLangSwitcherVisible="false"
                    v-bind:isServicesVisible="false"
                    v-on:toggleUserInfo="toggleUserInfo"
                    v-on:closeUserInfo="closeUserInfo"
                    v-on:toggleServices="toggleServices"
                    v-on:closeServices="closeServices"
                    v-on:update:langButtons="changeLang"
                )
                    template(slot="rsl-services")
                        transition(name='fade-in')
                            services-list.page-header__services-list(v-if='isShowServices')

                    template(slot="rsl-user-menu")
                        transition(name='fade-in')
                            rsl-user-menu(
                                v-if="isShowUserInfo"
                                v-bind:logoutLink="logoutLink"
                                v-bind:infoLinks="infoLinks"
                                v-bind:userName="getUserName"
                            )
                            +b.BUTTON.btn._login-block(slot="loginButton") Вход
            template(v-if="isMobile")
                +b.ARTICLE.header-mobile-panel
                    +e.logo.ROUTER-LINK(
                        title="Перейти на входную страницу"
                        v-bind:to="{ name: 'Enter', params: { id: $route.params.id }, query: {...$route.query} }"
                    )
                        v-icon(name="logo-neb-round")
                    +e.H2.title Национальная электронная библиотека
                    +e.BUTTON.menu.btn.btn_icon(
                        v-on:click="toggleMenu"
                        v-if="this.$route.name === 'Document' || getGeneralInfo.isLogin"
                    )
                        +e.V-ICON(name="menu")
                transition(name='fade')
                    keep-alive
                        menu-mobile(
                            v-if='isMobMenuVisible'
                            v-on:close="toggleMenu"
                        )
</template>

<script>
import { mapGetters } from 'vuex';
import RslHeaderTopLine from '@RSL/RslHeaderTopLine/RslHeaderTopLine';
import RslUserMenu from '@RSL/RslUserMenu/RslUserMenu';
import entry from '@/helpers/mixins/entry';
import ServicesList from '@/components/modules/ServicesList';

const MenuMobile = () => import('@/components/partials/MenuMobile');
const API_URL = process.env.VUE_APP_API_URL;
export default {
    components: {
        RslHeaderTopLine,
        RslUserMenu,
        MenuMobile,
        ServicesList
    },
    mixins: [entry],
    data() {
        return {
            isShowServices: false,
            isShowUserInfo: false,
            icons: {
                services: {
                    xlink: '/sprite.svg#service',
                    width: '16px',
                    height: '16px'
                }
            },
            currentLang: this.$i18n.locale
        };
    },
    computed: {
        ...mapGetters([
            'getGeneralInfo',
            'getUserName',
            'isMobile',
            'isMobMenuVisible'
        ]),
        infoLinks() {
            return [];
        },
        loginLink() {
            const { page = 1, rotate = 0, negative = 0 } = this.$route.query;
            const queryToLogin = `?page=${page}&rotate=${rotate}&negative=${negative}`;
            return `${API_URL}/esia-login?redirectUrl=${API_URL}/ru/viewer/${this.$route.params.id}${queryToLogin}`;
        }
    },
    methods: {
        changeLang(lang) {
            this.$i18n.locale = lang;
            this.currentLang = lang;
            this.$router.push({
                params: {
                    lang
                },
                query: {
                    ...this.$route.query
                }
            });
        },
        toggleUserInfo() {
            this.isShowUserInfo = !this.isShowUserInfo;
        },
        closeUserInfo() {
            this.isShowUserInfo = false;
        },
        toggleServices() {
            this.isShowServices = !this.isShowServices;
        },
        closeServices() {
            this.isShowServices = false;
        },
        toggleMenu() {
            this.$store.commit('SET_MOB_MENU_IS_VISIBLE', !this.isMobMenuVisible);
            document.body.classList.toggle('body-fixed');
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/partials/page-header.sass"></style>
